import { render, staticRenderFns } from "./UserMain.vue?vue&type=template&id=62d98260"
import script from "./UserMain.vue?vue&type=script&lang=js"
export * from "./UserMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports